export default __webpack_public_path__ + "static/media/fabParts.15175b57.jpg";